import { lazy } from "react"
import type { CustomRoute } from "@/shared/types"

const ConsumersComponent = lazy(async () => await import("@/pages/dashboard/control/consumers"))
const ConsumersViewComponent = lazy(async () => await import("@/pages/dashboard/control/consumers/View.tsx"))
const ConsumersFormComponent = lazy(async () => await import("@/pages/dashboard/control/consumers/Form"))

export const controlConsumersRoutes: CustomRoute = {
  path: "consumers",
  handle: { label: "Предприятия", i18Key: "consumers" },
  children: [
    {
      index: true,
      Component: ConsumersComponent
    },
    {
      path: "view/:consumerId",
      // TODO: change i18nkey
      handle: { hideTabs: true },
      Component: ConsumersViewComponent
    },
    {
      path: "create",
      handle: { label: "Добавить новый", hideTabs: true, i18Key: "create" },
      Component: ConsumersFormComponent
    },
    {
      path: "edit/:companyId",
      handle: { label: "Редактировать", hideTabs: true, i18Key: "edit" },
      Component: ConsumersFormComponent
    }
  ]
}
